<template>
  <div class="confirmation-wrapper">
    <div class="confirmation-box">
      <h1>{{ translations.order.title }}</h1>

      <p v-if="paymentStatus === 'success'">
        {{ translations.order.success }}
      </p>

      <p v-else-if="paymentStatus === 'pending'">
        {{ translations.order.pending }}
      </p>

      <p v-else-if="paymentStatus === 'failed'">
        {{ translations.order.failed }}
      </p>

      <p v-else>
        {{ translations.order.unknown }}
      </p>

      <p v-if="orderNumber" class="order-number">
        {{ translations.order.number }} <strong>{{ orderNumber }}</strong>
      </p>

      <p v-else class="order-number error">
        {{ translations.order.error }}<br />
        {{ translations.order.contact }}:
        <a href="mailto:biuro@birdstool.pl">biuro@birdstool.pl</a> {{ translations.order.or }} 
        <a href="tel:+48720992745">+48 720 992 745</a>
      </p>

      <router-link to="/" class="btn-return">
        ← {{ translations.order.back_home }}
      </router-link>
    </div>
  </div>
</template>

<script>
import { translations } from '@/locales/lang'
import axios from 'axios'

export default {
  name: 'AppOrderConfirmation',
  data() {
    return {
      paymentStatus: null
    }
  },
  computed: {
    translations() {
      return translations.value
    },
    orderNumber() {
      return this.$route?.query?.order || null
    },
    paymentId() {
      return this.$route?.query?.paymentId || null
    }
  },
  async mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' })

    if(this.paymentId) {
      try {
        const response = await axios.get(`/api/v1/paynow-payment-status/?paymentId=${this.paymentId}`)
        this.paymentStatus = response.data.status
      } catch (error) {
        console.error("Błąd pobierania statusu płatności:", error)
        this.paymentStatus = 'unknown'
      }
    } else {
      this.paymentStatus = 'unknown'
    }
  }
}
</script>

<style scoped>
.confirmation-wrapper {
  background: #f2f4f7;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
}

.confirmation-box {
  background: #fff;
  padding: 40px;
  border-radius: 16px;
  max-width: 600px;
  width: 100%;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  text-align: center;
}

.confirmation-box h1 {
  font-size: 2rem;
  margin-bottom: 10px;
}

.confirmation-box p {
  font-size: 1.1rem;
  margin: 10px 0;
}

.order-number {
  font-size: 1.2rem;
  font-weight: 600;
  color: #111;
  margin-top: 20px;
}

.btn-return {
  display: inline-block;
  margin-top: 32px;
  padding: 14px 28px;
  background: #111;
  color: #fff;
  font-weight: 600;
  border-radius: 10px;
  text-decoration: none;
  transition: background 0.2s ease;
}

.btn-return:hover {
  background: #000;
}

body, html {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow-x: hidden;
}
</style>
